<div class="modal-overlay">
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title">
        {{
          packageData && packageData.isDuplicate
            ? 'Duplicate Package'
            : packageData && !packageData.isDuplicate
              ? 'Edit Package'
              : 'Add Package'
        }}
      </h2>
      <button class="close-button" (click)="closeModal()">&times;</button>
    </div>
    <form [formGroup]="packageForm" (ngSubmit)="savePackage()" class="add-package-modal__form">
      <div class="modal-body">
        <div class="form-row">
          <div class="form-group">
            <label for="packageName">Package Name<span class="required">*</span></label>
            <input
              type="text"
              id="packageName"
              placeholder="e.g. Basic Wash"
              formControlName="package_name"
            />
            <div
              class="error-message"
              *ngIf="
                packageForm.get('package_name')?.invalid &&
                (packageForm.get('package_name')?.dirty ||
                  packageForm.get('package_name')?.touched ||
                  submitted)
              "
            >
              <span *ngIf="packageForm.get('package_name')?.errors?.['required']"
                >Package name is required</span
              >
              <span *ngIf="packageForm.get('package_name')?.errors?.['mustContainAlphanumeric']"
                >Package name must contain at least one letter or number</span
              >
            </div>
          </div>
          <div class="form-group status-group">
            <label>Status</label>
            <div class="status-toggle">
              <label class="switch">
                <input type="checkbox" formControlName="package_status" />
                <span class="slider round"></span>
              </label>
              <span>Active</span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Type of Package<span class="required">*</span></label>
          <mat-radio-group
            class="radio-button-group"
            formControlName="package_type"
            [class.has-error]="
              packageForm.get('package_type')?.invalid &&
              (packageForm.get('package_type')?.dirty ||
                packageForm.get('package_type')?.touched ||
                submitted)
            "
          >
            <div class="radio-option">
              <mat-radio-button value="car_wash" inputId="package_type_car_wash"></mat-radio-button>
              <label for="package_type_car_wash">Car Wash</label>
            </div>
            <div class="radio-option">
              <mat-radio-button
                value="detailing"
                inputId="package_type_detailing"
              ></mat-radio-button>
              <label for="package_type_detailing">Detailing</label>
            </div>
            <div class="radio-option">
              <mat-radio-button value="add_on" inputId="package_type_add_on"></mat-radio-button>
              <label for="package_type_add_on">Add on</label>
            </div>
          </mat-radio-group>
          <div
            class="error-message"
            *ngIf="
              packageForm.get('package_type')?.invalid &&
              (packageForm.get('package_type')?.dirty ||
                packageForm.get('package_type')?.touched ||
                submitted)
            "
          >
            <span *ngIf="packageForm.get('package_type')?.errors?.['required']"
              >Please select a package type</span
            >
          </div>
        </div>

        <ng-container *ngIf="isAddOnPackage()">
          <div class="form-group">
            <label>Paired with<span class="required">*</span></label>
            <div
              class="wash-type"
              [class.has-error]="
                packageForm.get('paired_with')?.invalid &&
                (packageForm.get('paired_with')?.dirty ||
                  packageForm.get('paired_with')?.touched ||
                  submitted)
              "
            >
              <div class="p-field-checkbox" *ngFor="let opt of pairedWithOptions">
                <mat-checkbox
                  [checked]="isPairedWithSelected(opt.value)"
                  (change)="onPairedWithToggle(opt.value, $event.checked)"
                ></mat-checkbox>
                <label>{{ opt.label }}</label>
              </div>
            </div>
            <div
              class="error-message"
              *ngIf="
                packageForm.get('paired_with')?.invalid &&
                (packageForm.get('paired_with')?.dirty ||
                  packageForm.get('paired_with')?.touched ||
                  submitted)
              "
            >
              <span *ngIf="packageForm.get('paired_with')?.errors?.['minPaired']"
                >Select at least one option</span
              >
            </div>
          </div>
          <div class="form-group add-on-variants-section" (click)="closeAllKebabs()">
            <button
              type="button"
              class="btn-add-variants"
              (click)="addAddOnVariant(); $event.stopPropagation()"
            >
              Add Variants
            </button>
            <div
              class="error-message"
              *ngIf="
                (submitted || packageForm.get('variants')?.touched) &&
                packageForm.get('variants')?.errors?.['minVariants']
              "
            >
              <span>Add at least one variant using Add Variants.</span>
            </div>
            <div formArrayName="variants" class="add-on-variant-list">
              <p class="add-on-saved-variants-title" *ngIf="hasAnySavedVariants()">Variants</p>
              <div
                *ngFor="let ctrl of variants.controls; let i = index"
                [formGroupName]="i"
                class="add-on-variant-item"
              >
                <!-- SAVED ROW (collapsed) -->
                <div
                  *ngIf="variantSavedStates[i]"
                  class="add-on-saved-variant-row"
                  (click)="$event.stopPropagation()"
                >
                  <mat-checkbox formControlName="is_active"></mat-checkbox>
                  <label [for]="'varActive' + i" class="add-on-saved-variant-name">{{
                    ctrl.get('variant_name')?.value
                  }}</label>
                  <button
                    type="button"
                    class="add-on-kebab-btn"
                    (click)="toggleVariantKebab(i, $event)"
                    [attr.aria-label]="'Options for ' + ctrl.get('variant_name')?.value"
                  >
                    <svg width="4" height="18" viewBox="0 0 4 18" fill="none">
                      <circle cx="2" cy="2" r="2" fill="#555963" />
                      <circle cx="2" cy="9" r="2" fill="#555963" />
                      <circle cx="2" cy="16" r="2" fill="#555963" />
                    </svg>
                  </button>
                  <div
                    class="add-on-kebab-menu"
                    *ngIf="variantKebabOpen[i]"
                    (click)="$event.stopPropagation()"
                  >
                    <button type="button" class="add-on-kebab-item" (click)="renameVariant(i)">
                      <span>Rename</span>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="add-on-kebab-item add-on-kebab-item--danger"
                      (click)="removeAddOnVariant(i)"
                    >
                      <span>Delete</span>
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <polyline points="3 6 5 6 21 6" />
                        <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                        <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                      </svg>
                    </button>
                  </div>
                </div>

                <!-- EDITING CARD (expanded) -->
                <div
                  *ngIf="!variantSavedStates[i]"
                  class="add-on-variant-card"
                  (click)="$event.stopPropagation()"
                >
                  <div class="form-group" *ngIf="!isAddOnDefaultPricingOnlyRow(i)">
                    <label [for]="'varName' + i">Variant Name<span class="required">*</span></label>
                    <input
                      type="text"
                      [id]="'varName' + i"
                      placeholder="e.g. Handwash"
                      formControlName="variant_name"
                    />
                    <div
                      class="error-message"
                      *ngIf="
                        ctrl.get('variant_name')?.invalid &&
                        (ctrl.get('variant_name')?.touched || submitted)
                      "
                    >
                      <span *ngIf="ctrl.get('variant_name')?.errors?.['required']"
                        >Name is required</span
                      >
                    </div>
                  </div>
                  <div class="add-on-pricing-row">
                    <div
                      class="add-on-pricing-inputs"
                      [class.add-on-pricing-inputs--dimmed]="isAddOnVariantCustomPrice(i)"
                    >
                      <div class="form-group add-on-field-compact">
                        <label [for]="'vList' + i"
                          >List Price<span class="required" *ngIf="!isAddOnVariantCustomPrice(i)"
                            >*</span
                          ></label
                        >
                        <input
                          type="number"
                          class="form-control"
                          [id]="'vList' + i"
                          [attr.placeholder]="
                            isAddOnDefaultPricingOnlyRow(i) ? 'e.g. $10' : 'e.g. $15'
                          "
                          formControlName="single_list_price"
                          min="0"
                          max="999999.99"
                          step="0.01"
                          [readonly]="isAddOnVariantCustomPrice(i)"
                          (input)="onAddOnVariantListInput($event, i)"
                        />
                        <div
                          class="error-message"
                          *ngIf="
                            !isAddOnVariantCustomPrice(i) &&
                            ctrl.errors?.['listRequired'] &&
                            (submitted || showAddOnVariantInlineErrors(i))
                          "
                        >
                          <span>List price is required</span>
                        </div>
                        <div
                          class="error-message"
                          *ngIf="
                            !isAddOnVariantCustomPrice(i) &&
                            ctrl.get('single_list_price')?.invalid &&
                            (submitted || showAddOnVariantInlineErrors(i))
                          "
                        >
                          <span *ngIf="ctrl.get('single_list_price')?.errors?.['maxDigits']"
                            >Price cannot exceed 999999.99</span
                          >
                          <span
                            *ngIf="
                              ctrl.get('single_list_price')?.errors?.[
                                'listPriceMustBeLessThanStrikeoffPrice'
                              ]
                            "
                            >List price must be less than strike-off price</span
                          >
                        </div>
                      </div>
                      <div class="form-group add-on-field-compact">
                        <label [for]="'vStrike' + i">Strike-off Price</label>
                        <input
                          type="number"
                          class="form-control"
                          [id]="'vStrike' + i"
                          placeholder="e.g. $15"
                          formControlName="single_strikeoff_price"
                          max="999999.99"
                          step="0.01"
                          [readonly]="isAddOnVariantCustomPrice(i)"
                          (input)="onAddOnVariantStrikeoffInput($event, i)"
                        />
                        <div
                          class="error-message"
                          *ngIf="
                            !isAddOnVariantCustomPrice(i) &&
                            ctrl.get('single_strikeoff_price')?.invalid &&
                            (submitted || showAddOnVariantInlineErrors(i))
                          "
                        >
                          <span *ngIf="ctrl.get('single_strikeoff_price')?.errors?.['maxDigits']"
                            >Price cannot exceed 999999.99</span
                          >
                          <span
                            *ngIf="
                              ctrl.get('single_strikeoff_price')?.errors?.[
                                'strikeoffPriceNotGreaterThanListPrice'
                              ]
                            "
                            >Strike-off price must be greater than list price</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="add-on-custom-price-toggle"
                      (click)="toggleCustomPrice(i); $event.stopPropagation()"
                    >
                      <span
                        class="add-on-radio-circle"
                        [class.add-on-radio-circle--on]="isAddOnVariantCustomPrice(i)"
                      ></span>
                      <span class="add-on-custom-price-label">Custom price</span>
                    </div>
                  </div>
                  <div
                    class="error-message"
                    *ngIf="
                      !isAddOnVariantCustomPrice(i) &&
                      (submitted || showAddOnVariantInlineErrors(i)) &&
                      ctrl.errors?.['listRequired']
                    "
                  >
                    <span>Enter a list price, or select Custom price.</span>
                  </div>
                  <!-- Quantity (single vs multiple units) applies per variant row only, not the package-level default pricing row. -->
                  <div class="form-group add-on-qty-group" *ngIf="!isAddOnDefaultPricingOnlyRow(i)">
                    <label class="add-on-label-inline">Quantity</label>
                    <div class="add-on-qty-row">
                      <div class="radio-option add-on-qty-native">
                        <input
                          type="radio"
                          [id]="'qsel_single_' + i"
                          [attr.name]="'addonVariantQty_' + i"
                          value="single"
                          formControlName="quantity_selection"
                        />
                        <label [for]="'qsel_single_' + i">Single</label>
                      </div>
                      <div class="radio-option add-on-qty-native">
                        <input
                          type="radio"
                          [id]="'qsel_mul_' + i"
                          [attr.name]="'addonVariantQty_' + i"
                          value="multiple"
                          formControlName="quantity_selection"
                        />
                        <label [for]="'qsel_mul_' + i">Multiple</label>
                      </div>
                    </div>
                  </div>
                  <div
                    class="add-on-variant-card__footer add-on-variant-card__footer--split"
                    *ngIf="!isAddOnDefaultPricingOnlyRow(i)"
                  >
                    <button
                      type="button"
                      class="btn-variant-cancel"
                      (click)="removeAddOnVariant(i)"
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      class="btn-variant-save"
                      (click)="onAddOnVariantCardSave(i)"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <div class="form-group" *ngIf="isCarWashPackage()">
          <label>Type of Wash<span class="required">*</span></label>
          <div
            class="wash-type"
            [class.has-error]="
              packageForm.get('wash_types')?.invalid &&
              (packageForm.get('wash_types')?.dirty ||
                packageForm.get('wash_types')?.touched ||
                submitted)
            "
          >
            <div class="p-field-checkbox">
              <mat-checkbox
                [checked]="isWashTypeSelected('single_wash')"
                (change)="onWashTypeToggle('single_wash', $event.checked)"
              ></mat-checkbox>
              <label>Single Wash</label>
            </div>
            <div class="p-field-checkbox">
              <mat-checkbox
                [checked]="isWashTypeSelected('monthly_membership')"
                (change)="onWashTypeToggle('monthly_membership', $event.checked)"
              ></mat-checkbox>
              <label>Monthly Membership</label>
            </div>
          </div>
          <div
            class="error-message"
            *ngIf="
              packageForm.get('wash_types')?.invalid &&
              (packageForm.get('wash_types')?.dirty ||
                packageForm.get('wash_types')?.touched ||
                submitted)
            "
          >
            <span *ngIf="packageForm.get('wash_types')?.errors?.['required']"
              >Please select at least one wash type</span
            >
          </div>
        </div>

        <!-- Detailing List Price Section -->
        <div *ngIf="isDetailingPackage()" class="add-on-variant-card">
          <div class="add-on-pricing-row">
            <div
              class="add-on-pricing-inputs"
              [class.add-on-pricing-inputs--dimmed]="isDetailingCustomPrice()"
            >
              <div class="form-group add-on-field-compact">
                <label for="detailingListPrice"
                  >List Price<span class="required" *ngIf="!isDetailingCustomPrice()"
                    >*</span
                  ></label
                >
                <input
                  type="number"
                  class="form-control"
                  id="detailingListPrice"
                  placeholder="e.g. $200"
                  formControlName="single_list_price"
                  min="0"
                  max="999999.99"
                  step="0.01"
                  [readonly]="isDetailingCustomPrice()"
                  (input)="onListPriceInput($event, 'single_list_price')"
                />
                <div
                  class="error-message"
                  *ngIf="
                    !isDetailingCustomPrice() &&
                    packageForm.get('single_list_price')?.invalid &&
                    (packageForm.get('single_list_price')?.dirty ||
                      packageForm.get('single_list_price')?.touched ||
                      submitted)
                  "
                >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['required']"
                    >List price is required for detailing package</span
                  >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['min']"
                    >List price must be at least 1</span
                  >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['maxDigits']"
                    >Price cannot exceed 999999.99</span
                  >
                  <span
                    *ngIf="
                      packageForm.get('single_list_price')?.errors?.[
                        'listPriceMustBeLessThanStrikeoffPrice'
                      ]
                    "
                    >List price must be less than strike-off price</span
                  >
                </div>
              </div>
              <div class="form-group add-on-field-compact">
                <label for="detailingStrikeOffPrice">Strike-off Price</label>
                <input
                  type="number"
                  class="form-control"
                  id="detailingStrikeOffPrice"
                  placeholder="e.g. $250"
                  formControlName="single_strikeoff_price"
                  max="999999.99"
                  step="0.01"
                  [readonly]="isDetailingCustomPrice()"
                  (input)="onStrikeoffPriceInput($event, 'single_strikeoff_price')"
                />
                <div
                  class="error-message"
                  *ngIf="
                    !isDetailingCustomPrice() &&
                    packageForm.get('single_strikeoff_price')?.invalid &&
                    (packageForm.get('single_strikeoff_price')?.dirty ||
                      packageForm.get('single_strikeoff_price')?.touched ||
                      submitted)
                  "
                >
                  <span *ngIf="packageForm.get('single_strikeoff_price')?.errors?.['maxDigits']"
                    >Price cannot exceed 999999.99</span
                  >
                  <span
                    *ngIf="
                      packageForm.get('single_strikeoff_price')?.errors?.[
                        'strikeoffPriceNotGreaterThanListPrice'
                      ]
                    "
                    >Strike-off price must be greater than list price</span
                  >
                </div>
              </div>
            </div>
            <button
              type="button"
              class="add-on-custom-price-toggle"
              (click)="toggleDetailingCustomPrice(); $event.stopPropagation()"
              [attr.aria-pressed]="isDetailingCustomPrice()"
            >
              <span
                class="add-on-radio-circle"
                [class.add-on-radio-circle--on]="isDetailingCustomPrice()"
                aria-hidden="true"
              ></span>
              <span class="add-on-custom-price-label">Custom price</span>
            </button>
          </div>
          <div
            class="error-message"
            *ngIf="
              !isDetailingCustomPrice() &&
              packageForm.get('single_list_price')?.errors?.['required'] &&
              (submitted ||
                packageForm.get('single_list_price')?.touched ||
                packageForm.get('single_list_price')?.dirty)
            "
          >
            <span>Enter a list price, or select Custom price.</span>
          </div>
        </div>

        <div class="single-wash-options" *ngIf="isSingleWashSelected()">
          <p class="options-title">Single Wash Options<span class="required">*</span></p>
          <div class="add-on-pricing-row">
            <div
              class="add-on-pricing-inputs"
              [class.add-on-pricing-inputs--dimmed]="isSingleWashCustomPrice()"
            >
              <div class="form-group add-on-field-compact">
                <label for="listPrice"
                  >List Price<span class="required" *ngIf="!isSingleWashCustomPrice()"
                    >*</span
                  ></label
                >
                <input
                  type="number"
                  class="form-control"
                  id="listPrice"
                  placeholder="e.g. $10"
                  formControlName="single_list_price"
                  min="0"
                  max="999999.99"
                  step="0.01"
                  [readonly]="isSingleWashCustomPrice()"
                  (input)="onListPriceInput($event, 'single_list_price')"
                />
                <div
                  class="error-message"
                  *ngIf="
                    !isSingleWashCustomPrice() &&
                    packageForm.get('single_list_price')?.invalid &&
                    (packageForm.get('single_list_price')?.dirty ||
                      packageForm.get('single_list_price')?.touched ||
                      submitted)
                  "
                >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['required']"
                    >List price is required for single wash</span
                  >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['min']"
                    >List price must be at least 1</span
                  >
                  <span *ngIf="packageForm.get('single_list_price')?.errors?.['maxDigits']"
                    >Price cannot exceed 999999.99</span
                  >
                  <span
                    *ngIf="
                      packageForm.get('single_list_price')?.errors?.[
                        'listPriceMustBeLessThanStrikeoffPrice'
                      ]
                    "
                    >List price must be less than strike-off price</span
                  >
                </div>
              </div>
              <div class="form-group add-on-field-compact">
                <label for="strikeOffPrice">Strike-off Price</label>
                <input
                  type="number"
                  class="form-control"
                  id="strikeOffPrice"
                  placeholder="e.g. $15"
                  formControlName="single_strikeoff_price"
                  max="999999.99"
                  step="0.01"
                  [readonly]="isSingleWashCustomPrice()"
                  (input)="onStrikeoffPriceInput($event, 'single_strikeoff_price')"
                />
                <div
                  class="error-message"
                  *ngIf="
                    !isSingleWashCustomPrice() &&
                    packageForm.get('single_strikeoff_price')?.invalid &&
                    (packageForm.get('single_strikeoff_price')?.dirty ||
                      packageForm.get('single_strikeoff_price')?.touched ||
                      submitted)
                  "
                >
                  <span *ngIf="packageForm.get('single_strikeoff_price')?.errors?.['maxDigits']"
                    >Price cannot exceed 999999.99</span
                  >
                  <span
                    *ngIf="
                      packageForm.get('single_strikeoff_price')?.errors?.[
                        'strikeoffPriceNotGreaterThanListPrice'
                      ]
                    "
                    >Strike-off price must be greater than list price</span
                  >
                </div>
              </div>
            </div>
            <div
              class="add-on-custom-price-toggle"
              (click)="toggleSingleWashCustomPrice(); $event.stopPropagation()"
            >
              <span
                class="add-on-radio-circle"
                [class.add-on-radio-circle--on]="isSingleWashCustomPrice()"
              ></span>
              <span class="add-on-custom-price-label">Custom price</span>
            </div>
          </div>
          <div
            class="error-message"
            *ngIf="
              !isSingleWashCustomPrice() &&
              packageForm.get('single_list_price')?.errors?.['required'] &&
              (submitted ||
                packageForm.get('single_list_price')?.touched ||
                packageForm.get('single_list_price')?.dirty)
            "
          >
            <span>Enter a list price, or select Custom price.</span>
          </div>
        </div>

        <div class="monthly-membership-options" *ngIf="isMonthlyMembershipSelected()">
          <p class="options-title">Monthly Membership Options<span class="required">*</span></p>
          <div class="form-row">
            <div class="form-group">
              <div class="wash-count">
                <label>Wash count </label>
                <mat-select
                  formControlName="wash_count_period"
                  placeholder="Select period"
                  class="form-select max-w-200"
                >
                  <mat-option *ngFor="let option of washCountPeriodOptions" [value]="option.value">
                    {{ option.label }}
                  </mat-option>
                </mat-select>
                <span *ngIf="!isWashCountPeriodUnlimited()">=</span>
                <input
                  *ngIf="!isWashCountPeriodUnlimited()"
                  type="text"
                  class="form-control"
                  placeholder="e.g. 2"
                  formControlName="wash_count_frequency"
                  (input)="onWashCountFrequencyInput($event)"
                />
                <span *ngIf="isWashCountPeriodUnlimited()" class="wash-count-unlimited-label"
                  >Unlimited</span
                >
              </div>
              <div
                class="error-message"
                style="text-align: right"
                *ngIf="
                  packageForm.get('wash_count_frequency')?.invalid &&
                  (packageForm.get('wash_count_frequency')?.dirty ||
                    packageForm.get('wash_count_frequency')?.touched ||
                    submitted)
                "
              >
                <span
                  *ngIf="
                    packageForm.get('wash_count_frequency')?.errors?.['required'] ||
                    packageForm.get('wash_count_frequency')?.errors?.['min']
                  "
                  >Enter a wash count of at least 1</span
                >
                <span *ngIf="packageForm.get('wash_count_frequency')?.errors?.['maxDigits']"
                  >Wash count cannot exceed 3 digits</span
                >
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group">
              <label for="monthlyListPrice">List Price/mo<span class="required">*</span></label>
              <input
                type="number"
                class="form-control"
                id="monthlyListPrice"
                placeholder="e.g. $10"
                formControlName="monthly_list_price"
                min="0"
                max="999999.99"
                step="0.01"
                (input)="onListPriceInput($event, 'monthly_list_price')"
              />
              <div
                class="error-message"
                *ngIf="
                  packageForm.get('monthly_list_price')?.invalid &&
                  (packageForm.get('monthly_list_price')?.dirty ||
                    packageForm.get('monthly_list_price')?.touched ||
                    submitted)
                "
              >
                <span *ngIf="packageForm.get('monthly_list_price')?.errors?.['required']"
                  >List price is required for monthly membership</span
                >
                <span *ngIf="packageForm.get('monthly_list_price')?.errors?.['min']"
                  >List price must be at least 1</span
                >
                <span *ngIf="packageForm.get('monthly_list_price')?.errors?.['maxDigits']"
                  >Price cannot exceed 999999.99</span
                >
                <span
                  *ngIf="
                    packageForm.get('monthly_list_price')?.errors?.[
                      'listPriceMustBeLessThanStrikeoffPrice'
                    ]
                  "
                  >List price must be less than strike-off price</span
                >
              </div>
            </div>
            <div class="form-group">
              <label for="monthlyStrikeOffPrice">Strike-off Price/mo</label>
              <input
                type="number"
                class="form-control"
                id="monthlyStrikeOffPrice"
                placeholder="e.g. $15"
                formControlName="monthly_strikeoff_price"
                max="999999.99"
                step="0.01"
                (input)="onStrikeoffPriceInput($event, 'monthly_strikeoff_price')"
              />
              <div
                class="error-message"
                *ngIf="
                  packageForm.get('monthly_strikeoff_price')?.invalid &&
                  (packageForm.get('monthly_strikeoff_price')?.dirty ||
                    packageForm.get('monthly_strikeoff_price')?.touched ||
                    submitted)
                "
              >
                <span *ngIf="packageForm.get('monthly_strikeoff_price')?.errors?.['maxDigits']"
                  >Price cannot exceed 999999.99</span
                >
                <span
                  *ngIf="
                    packageForm.get('monthly_strikeoff_price')?.errors?.[
                      'strikeoffPriceNotGreaterThanListPrice'
                    ]
                  "
                  >Strike-off price must be greater than list price</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="showFamilyEligible()">
          <label>Family Plan Applicable?</label>
          <mat-radio-group class="radio-button-group" formControlName="family_eligible">
            <div class="radio-option">
              <mat-radio-button value="yes" id="family_eligible_yes"></mat-radio-button>
              <label for="family_eligible_yes-input">Yes</label>
            </div>
            <div class="radio-option">
              <mat-radio-button value="no" id="family_eligible_no"></mat-radio-button>
              <label for="family_eligible_no-input">No</label>
            </div>
          </mat-radio-group>
        </div>

        <div class="form-group add-on-features-before-location" *ngIf="!isAddOnPackage()">
          <label>Package features<span class="required">*</span></label>
          <div class="features-search">
            <input
              type="text"
              placeholder="Search for features.."
              [value]="searchTerm"
              (input)="onSearchFeatures($event)"
            />
            <img src="assets/images/package/search.svg" alt="Search" />
          </div>
          <div
            class="features-checkboxes"
            [class.has-error]="
              packageForm.get('features')?.invalid &&
              (packageForm.get('features')?.dirty ||
                packageForm.get('features')?.touched ||
                submitted)
            "
          >
            <div class="p-field-checkbox" *ngFor="let feature of getVisibleFeatures()">
              <mat-checkbox
                [checked]="isFeatureSelected(feature)"
                (change)="onFeatureToggle(feature, $event.checked)"
              ></mat-checkbox>
              <label>{{ feature.name }}</label>
            </div>
            <div
              *ngIf="searchTerm.trim() && getFilteredFeatures().length === 0"
              class="no-data-message error-message"
            >
              <p>No Features found</p>
            </div>
          </div>
          <button
            type="button"
            class="text-link"
            *ngIf="shouldShowToggleButton()"
            (click)="toggleShowAllFeatures()"
          >
            {{ showAllFeatures ? 'Show less' : 'Show all (' + getFilteredCount() + ')' }}
          </button>
          <div
            class="error-message"
            *ngIf="
              packageForm.get('features')?.invalid &&
              (packageForm.get('features')?.dirty ||
                packageForm.get('features')?.touched ||
                submitted)
            "
          >
            <span *ngIf="packageForm.get('features')?.errors?.['required']"
              >Please select at least one feature</span
            >
          </div>
        </div>

        <div class="form-group">
          <label>Location<span class="required">*</span></label>
          <div
            class="location-checkboxes"
            [class.has-error]="
              packageForm.get('locations')?.invalid &&
              (packageForm.get('locations')?.dirty ||
                packageForm.get('locations')?.touched ||
                submitted)
            "
          >
            <div class="p-field-checkbox" *ngFor="let location of locations">
              <mat-checkbox
                [checked]="isLocationSelected(location)"
                (change)="onLocationToggle(location, $event.checked)"
              ></mat-checkbox>
              <label>{{ location.branch }}</label>
            </div>
          </div>
          <div
            class="error-message"
            *ngIf="
              packageForm.get('locations')?.invalid &&
              (packageForm.get('locations')?.dirty ||
                packageForm.get('locations')?.touched ||
                submitted)
            "
          >
            <span *ngIf="packageForm.get('locations')?.errors?.['required']"
              >Please select at least one location</span
            >
          </div>
          <div *ngIf="locations.length === 0">
            <p class="error-message">
              No locations found. Please
              <a (click)="createLocation()" class="link-text">create a location</a> first.
            </p>
            <!-- <button type="button" class="btn btn-primary btn-medium" (click)="createLocation()">Create Location</button> -->
          </div>
        </div>

        <!-- CWS-1921: only for car wash packages at locations whose tunnel has wash packages. -->
        <div
          class="form-group tunnel-wash-field"
          *ngFor="let field of tunnelWashFields; trackBy: trackTunnelWashField"
        >
          <label [attr.for]="'tunnel-wash-' + field.locationId">{{ field.label }}</label>
          <select
            class="tunnel-wash-select"
            [id]="'tunnel-wash-' + field.locationId"
            [attr.data-location-id]="field.locationId"
            (change)="onTunnelWashSelect(field.locationId, $event)"
          >
            <option
              *ngFor="let option of field.options"
              [value]="option.value ?? ''"
              [selected]="option.value === tunnelWashValue(field)"
            >
              {{ option.label }}
            </option>
          </select>
          <p class="tunnel-wash-hint">{{ tunnelWashHint }}</p>
        </div>

        <div class="form-group">
          <label>License Plate Required?<span class="required">*</span></label>
          <mat-radio-group
            class="radio-button-group"
            formControlName="license_plate_needed"
            [class.has-error]="
              packageForm.get('license_plate_needed')?.invalid &&
              (packageForm.get('license_plate_needed')?.dirty ||
                packageForm.get('license_plate_needed')?.touched ||
                submitted)
            "
          >
            <div class="p-field-radiobutton">
              <mat-radio-button value="yes" inputId="lp_yes"></mat-radio-button>
              <label for="lp_yes">Yes</label>
            </div>
            <div class="p-field-radiobutton">
              <mat-radio-button value="no" inputId="lp_no"></mat-radio-button>
              <label for="lp_no">No</label>
            </div>
          </mat-radio-group>
          <div
            class="error-message"
            *ngIf="
              packageForm.get('license_plate_needed')?.invalid &&
              (packageForm.get('license_plate_needed')?.dirty ||
                packageForm.get('license_plate_needed')?.touched ||
                submitted)
            "
          >
            <span *ngIf="packageForm.get('license_plate_needed')?.errors?.['required']"
              >Please select license plate requirement</span
            >
          </div>
        </div>

        <div class="form-group">
          <app-theme-color-picker formControlName="theme_color"></app-theme-color-picker>
        </div>
      </div>
      <app-modal-footer-actions
        footerClass="modal-footer"
        secondaryText="Clear"
        [primaryText]="packageData && !packageData.isDuplicate ? 'Save' : 'Save '"
        primaryLoadingText="Saving..."
        primaryButtonType="submit"
        [secondaryDisabled]="!hasFormChanges"
        [primaryDisabled]="!packageForm.valid || isSubmitting"
        [primaryLoading]="isSubmitting"
        [primaryExtraClass]="{ disabled: !packageForm.valid || isSubmitting }"
        (secondaryClick)="clearForm()"
        (cancelClick)="closeModal()"
      />
    </form>
  </div>
</div>
